import { GridColumnType } from "../../../data/gridColumnType";

export const GroupManagementGridConfig = {
    columns: [
        {
            name: "Group Name",
            fieldName: "groupName",
            allowShort: false,
            colStyle: {
                width: "30%",
                textAlign: "center",
            },
        },
          {
            name: "Group Member",
            fieldName: "groupMember",
            allowShort: false,
            colStyle: {
                width: "30%",
                textAlign: "center",
            },
        },
          {
            name: "Group Project",
            fieldName: "groupProject",
            allowShort: false,
            colStyle: {
                width: "30%",
                textAlign: "center",
            },
        },
        {
            name: "Action",
            colType: GridColumnType.ACTION,
            defaultAction: {
                allowEdit: true,
                allowDelete: true,
            },
        },

    ]
}